import React from "react";
import { Modal, Box, Typography, Button, IconButton } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import "./MyTechProfileSuccessModal.css";

const MyTechProfileSuccessModal = ({ open, onClose, portfolioUrl }) => {
  const handleClose = (event, reason) => {
    if (reason === "backdropClick") return;
    onClose();
  };

  const handleGoHome = () => {
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="success-modal-title"
      aria-describedby="success-modal-description"
    >
      <Box className="success-modal-box">
        <IconButton
          aria-label="close"
          onClick={onClose}
          className="success-modal-close-button"
        >
          <CloseIcon />
        </IconButton>
        <CheckCircleOutlineIcon className="success-modal-icon" />
        <Typography
          id="success-modal-title"
          variant="h5"
          component="h2"
          className="success-modal-title"
        >
          Your Portfolio is Live!
        </Typography>
        <Typography
          id="success-modal-description"
          sx={{ mt: 2 }}
          className="success-modal-subtitle"
        >
          Congratulations! Your digital portfolio has been successfully
          published and is now available for the world to see.
        </Typography>
        <Box className="success-modal-actions">
          <Button
            variant="contained"
            className="success-modal-view-button"
            href={portfolioUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            View Your Portfolio
          </Button>
          <Button
            variant="outlined"
            className="success-modal-home-button"
            onClick={handleGoHome}
          >
            Go to Home
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default MyTechProfileSuccessModal;
